import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { PenIcon } from "@common/penIcon";
import { CrossIcon } from "@common/crossIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function ViewToggle({ mode, setMode }: Props) {
  const { t } = useTranslation();
  const isReading = mode === "read";

  return (
    <div
      className={classNames(styles.viewToggle, { [styles.read]: isReading })}
      onClick={() => setMode(isReading ? "write" : "read")}
    >
      <div className={styles.iconBox}>
        {isReading ? (
          <PenIcon className={styles.icon} />
        ) : (
          <CrossIcon className={styles.icon} />
        )}
      </div>
      <p className={styles.text}>
        {isReading
          ? t("planzoneParametersPage.organization.write")
          : t("planzoneParametersPage.organization.read")}
      </p>
    </div>
  );
}

export { ViewToggle };
